<template>
  <v-card>
    <v-tabs show-arrows v-model="tab">
      <v-tab v-if="roleParticipant" :key="'InfoPersonnel'">
        {{ $t('user.infoPersonnelles') }}
      </v-tab>
      <v-tab class="tabProfessionnel">
        {{ $t('user.infoProfessionnelles') }}
      </v-tab>
      <v-tab v-if="roleCorrespondant">
        {{ $t('user.infoAdresse') }}
      </v-tab>
      <v-tab v-if="roleCorrespondant && !isCorrespondantEtb">
        {{ $t('user.infoEtablissement') }}
      </v-tab>

      <v-tab-item v-if="roleParticipant" :key="'InfoPersonnel'" eager>
        <coordonneesPersonnels />
      </v-tab-item>
      <v-tab-item :key="'professionnel'" eager>
        <template v-if="roleCorrespondant">
          <detailCorrespondant
            @isEtb="isCorrespondantEtablissement"
            @isEnt="isCorrespondantEntreprise"
          />
        </template>
        <template v-if="roleParticipant">
          <detailAdherent />
        </template>
      </v-tab-item>
      <v-tab-item v-if="roleCorrespondant" :key="'adresse'" eager>
        <detailSociete
          :isCorrespondantEtablissement="isCorrespondantEtb"
          :isCorrespondantEntreprise="isCorrespondantEnt"
        />
      </v-tab-item>
      <v-tab-item v-if="roleCorrespondant" :key="'etablissements'">
        <listeEtablissementAdresse />
      </v-tab-item>
    </v-tabs>

    <c-dialog persistent :dialog="modalLeave" max-width="50%">
      <alert-leave
        :alertTitle="$t('leaveTitle')"
        :alertMessage="$t('leaveConfirm')"
        @confirm="
          modalLeave = false
          $store.commit('modif/modified', false)
          next()
        "
        @cancel="modalLeave = false"
      />
    </c-dialog>
  </v-card>
</template>

<script>
import DetailCorrespondant from '@/view/Correspondants/DetailCorrespondant'
import DetailSociete from '@/view/Correspondants/DetailSociete'
import ListeEtablissementAdresse from '@/view/Correspondants/ListeEtablissementAdresse'
import CoordonneesPersonnelles from '@/view/Coordonnees/CoordonneesPersonnelles'
import DetailAdherent from '@/view/Adherents/DetailAdherent'

// const NAMESPACE = 'correspondant';

export default {
  components: {
    detailCorrespondant: DetailCorrespondant,
    coordonneesPersonnels: CoordonneesPersonnelles,
    detailAdherent: DetailAdherent,
    DetailSociete: DetailSociete,
    ListeEtablissementAdresse: ListeEtablissementAdresse,
  },
  provide() {
    return {
      $vroot: this.$v,
    }
  },
  beforeRouteLeave(to, from, next) {
    if (this.$store.getters['modif/formModified'] && to.path != '/login') {
      this.modalLeave = true
      this.next = next
    } else {
      next()
    }
  },
  data() {
    return {
      tab: null,
      modalLeave: false,
      isCorrespondantEtb: false,
      isCorrespondantEnt: false,
    }
  },
  created() {},
  mounted() {},
  computed: {
    roleCorrespondant() {
      return this.$auth.hasRole('ROLE_CORRESPONDANT')
    },
    roleParticipant() {
      return this.$auth.hasRole('ROLE_PARTICIPANT')
    },
  },
  watch: {},
  methods: {
    isCorrespondantEtablissement($event) {
      this.isCorrespondantEtb = $event
    },
    isCorrespondantEntreprise($event) {
      this.isCorrespondantEnt = $event
    },
  },
  validations: {
    form: {
      contact: {},
    },
  },
}
</script>

<style scoped>
.v-tab.v-tab:not(.v-tab--active) {
  background-color: darkcyan;
  color: aliceblue !important;
}
</style>
